import {
    INPUT_TYPE_TEXT,
    INPUT_TYPE_EMAIL,
    INPUT_TYPE_PHONE_NUMBER,
    INPUT_TYPE_URL,
    INPUT_TYPE_NUMBER,
    INPUT_TYPE_ADDRESS,
    INPUT_TYPE_PARAGRAPH,
    INPUT_TYPE_SELECT,
} from 'common/entities/formNode/inputTypes';

export const PLACEHOLDER_TEXT_ALLOWED_INPUT_TYPES = {
    [INPUT_TYPE_TEXT]: true,
    [INPUT_TYPE_EMAIL]: true,
    [INPUT_TYPE_PHONE_NUMBER]: true,
    [INPUT_TYPE_URL]: true,
    [INPUT_TYPE_NUMBER]: true,
    [INPUT_TYPE_ADDRESS]: true,
    [INPUT_TYPE_PARAGRAPH]: true,
    [INPUT_TYPE_SELECT]: true,
};
